module.exports = __webpack_public_path__ + "static/img/AI审核_image@2x.09a0875b.png";